import { setInstance, type DataDogRum } from './instance';

/**
 * Initializes DataDog RUM instance for observability tracking.
 *
 * @param datadogRum - The DataDog RUM instance to initialize
 */
export function initializeDatadog(datadogRum: DataDogRum) {
  setInstance(datadogRum);
}
